import React from 'react';
import {assert} from 'assert-ts';
import type {DataSimpleValue} from '../../schemaDefinition/types';
import {FlexBox} from '../layout';

type Props = {
  suggestions: DataSimpleValue[];
};

export const SuggestionsPreview: React.FC<Props> = ({suggestions}) => {
  return <div>{suggestions.map(RenderSuggestionsPreview)}</div>;
};

const RenderSuggestionsPreview = (suggestion: DataSimpleValue) => {
  if (typeof suggestion === 'string') {
    return <FlexBox horizontal>{suggestion}</FlexBox>;
  }

  assert.soft(
    false,
    `SuggestionsPreview: Unsupported suggestion type: ${typeof suggestion}`,
  );

  return null;
};
